import React from "react";
import { useTranslation } from "react-i18next";

function NotificationLegal() 
{

    var translationHook = useTranslation();
    var t = translationHook.t;

    React.useEffect(function() 
    {
        var hasSeenLegalNotice = localStorage.getItem("hasSeenLegalNotice");

        if (!hasSeenLegalNotice) 
        {
            setTimeout(function() {
                if (window.UIkit && window.UIkit.notification) {
                    var part1 = t("ui.overlay.popup.legal-notice.1");
                    var part2 = t("ui.overlay.popup.legal-notice.2");

                    window.UIkit.notification({
                        message:
                            '<div style="font-size:12px; line-height:1.4; max-width:90vw; white-space:normal;">' +
                            '<span uk-icon="icon: info" style="margin-right:4px;"></span> ' +
                            part1 +
                            ' <a href="/terms-of-service" style="text-decoration:underline;">Terms of Service</a>, ' +
                            '<a href="/privacy-policy" style="text-decoration:underline;">Privacy Policy</a>' +
                            part2 +
                            '</div>',
                        pos: 'bottom-center',
                        timeout: 0
                    });
                }

                localStorage.setItem("hasSeenLegalNotice", "true");
            }, 2400);
        }
    }, []);

    return null;
}

export default NotificationLegal;